import ReactMarkdown from 'react-markdown'
import rehypeExternalLinks from 'rehype-external-links'
import rehypeRaw from 'rehype-raw'
import { StyledMarkdownContainer } from 'components/common/MarkdownDisplay/MarkdownDisplay.style'

export const MarkdownDisplay = ({ children }: { children: string }) => {
  return (
    <StyledMarkdownContainer>
      <ReactMarkdown
        rehypePlugins={[
          rehypeRaw as any,
          [rehypeExternalLinks, { target: '_blank', rel: ['nofollow'] }]
        ]}
      >
        {children}
      </ReactMarkdown>
    </StyledMarkdownContainer>
  )
}
